var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var Svg18PxOpenRectArrowIn = function Svg18PxOpenRectArrowIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "M13.25 2h-3.5a.75.75 0 0 0 0 1.5h3.5c.689 0 1.25.561 1.25 1.25v8.5c0 .689-.561 1.25-1.25 1.25h-3.5a.75.75 0 0 0 0 1.5h3.5A2.75 2.75 0 0 0 16 13.25v-8.5A2.75 2.75 0 0 0 13.25 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#56565C",
    d: "m10.78 8.47-3.5-3.5a.75.75 0 1 0-1.061 1.061l2.22 2.22H2.75a.75.75 0 0 0 0 1.5h5.689l-2.22 2.22a.75.75 0 0 0 1.06 1.061l3.5-3.5a.75.75 0 0 0 0-1.061z"
  })));
};
export default Svg18PxOpenRectArrowIn;